import { useState, useRef, useLayoutEffect } from "react";
import { Default } from "../../components/Default/Default";
import { useOtbPlanningViewModel } from "../../viewModel/useOtbPlanningViewModel";

import { OpenVsExcessosSection } from "./components/OpenVsExcessos/OpenVsExcessosSection";

import { PerformanceSection } from "./components/PerformanceSection";
// import { SetupSection } from "./components/SetupSection";
import { NovoOtbModal } from "./components/NovoOtbModal";

import { useOtbViewModel } from "../../viewModel/useOtbVewModel";

import { LoadingContent } from "../../components/SharedComponents/sharedComponents.index";
import { LOADING_CONTENT_TYPE } from "../../components/SharedComponents/LoadingContent/loading.content.constants";
import { OTB_VIEWS } from "../../components/components.constants";
import { SYSTEM_COLORS } from "../../components/system.colors";

// icones
const IconChart = ({ size = 16, color = "currentColor" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 16 16" fill={color}>
      <rect x="1" y="9" width="3" height="6" rx="0.8" />
      <rect x="6.5" y="5" width="3" height="10" rx="0.8" />
      <rect x="12" y="2" width="3" height="13" rx="0.8" />
    </svg>
  );
}

const IconGear = ({ size = 16, color = "currentColor" }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

// componentes
const SidebarNavItem = ({ actions, ctx, uiState, icon, children }) => {
  
  const { onToggle, onClick } = actions || {};
  const { label } = ctx ||{};
  const { active, expanded } = uiState || {};

  return (
    <div>
      <div style={{
        display: "flex", alignItems: "center",
        borderRadius: "10px",
        background: active ? "rgba(232,119,58,0.1)" : "transparent",
      }}>
        <button
          onClick={onClick}
          style={{
            flex: 1, display: "flex", alignItems: "center", gap: 10,
            padding: "9px 12px", border: "none",
            background: "none", cursor: "pointer",
            color: active ? "#e8773a" : "#555",
            fontWeight: active ? "700" : "500",
            fontSize: "13.5px", textAlign: "left",
          }}
        >
          <span style={{ fontSize: "16px", display: "flex", alignItems: "center" }}>{icon}</span>
          <span>{label}</span>
        </button>

        {!!children && (
          <button
            onClick={onToggle}
            style={{
              background: "none", border: "none", cursor: "pointer",
              padding: "9px 12px", display: "flex", alignItems: "center",
            }}
          >
            <span style={{
              fontSize: "11px", color: "#aaa",
              display: "inline-block",
              transform: expanded ? "rotate(180deg)" : "none",
              transition: "transform 0.2s",
            }}>▾</span>
          </button>
        )}
      </div>

      {expanded && (
        <div style={{ paddingLeft: 16, marginTop: 4 }}>
          {children}
        </div>
      )}
    </div>
  );
};

export const SidebarForOtb = ({ actions, uiState }) => {

  const { setActiveView, onWidthChange } = actions || {};

  const { activeView, displayTabs, showSidebar = false } = uiState || {};

  const {
    performanceTab = true,
    setupTab = false,
  } = displayTabs || {}


  const asideRef = useRef(null);
  useLayoutEffect(() => {
    if (!onWidthChange) return;
    if (!showSidebar) {
      onWidthChange(0);
      return;
    }
    const el = asideRef.current;
    if (!el) return;
    const report = () => onWidthChange(el.offsetWidth);
    report();
    const ro = new ResizeObserver(report);
    ro.observe(el);
    return () => ro.disconnect();
  }, [onWidthChange, showSidebar]);

  if (!showSidebar) return null;

  return (
    <aside ref={asideRef} style={{
      inlineSize: "fit-content",
      backgroundColor: "#fff",
      borderRight: "1px solid #eee",
      display: "flex", flexDirection: "column",
      padding: "0 8px",
      position: "fixed",
      top: 0,
      left: 72,
      height: "100vh",
      overflowY: "auto",
      zIndex: 500,
    }}>
      {/* Seção superior do OTB */}
      <section style={{ padding: "20px 8px 16px", display: "flex", alignItems: "center", gap: 10, borderBottom: "1px solid #f0f0f0", marginBottom: 8 }}>
        <div style={{
          inlineSize: 36, blockSize: 36, borderRadius: "10px",
          backgroundColor: "#e8773a",
          display: "flex", alignItems: "center", justifyContent: "center",
          flexShrink: 0 }}>
          
          {/* ícone de trend */}
          <svg width={18} height={18} viewBox="0 0 24 24" fill="none" stroke={"#fff"} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="3,17 9,11 13,15 21,7" />
            <polyline points="14,7 21,7 21,14" />
          </svg>
        </div>

        <hgroup>
          <p style={{ fontSize: "14px", fontWeight: "700", color: "#1a1a1a", lineHeight: 1.2 }}>
            OTB Planning
          </p>

          <p style={{ fontSize: "11px", color: "#999" }}>
            Open to Buy
          </p>
        </hgroup>
      </section>

      {/* Opções de OTB */}
      <div style={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}>
        {performanceTab && (
          <SidebarNavItem
            actions={{ onClick: () => setActiveView(OTB_VIEWS.OTB_PERFORMANCE.VALUE) }}
            ctx={{ label: OTB_VIEWS.OTB_PERFORMANCE.LABEL }}
            uiState={{ active: activeView === OTB_VIEWS.OTB_PERFORMANCE.VALUE }}
            icon={<IconChart size={15} color={activeView === OTB_VIEWS.OTB_PERFORMANCE.VALUE ? "#e8773a" : "#555"} />}
          />          
        )}

        {setupTab && (
          <SidebarNavItem
            actions={{ onClick: () => setActiveView(OTB_VIEWS.OTB_CONFIGURATION) }}
            ctx={{ label: OTB_VIEWS.OTB_CONFIGURATION.LABEL }}
            uiState={{ active: activeView === OTB_VIEWS.OTB_CONFIGURATION }}
            icon={<IconGear size={15} color={activeView === OTB_VIEWS.OTB_CONFIGURATION ? "#e8773a" : "#555"} />}
          />          
        )}
      </div>
    </aside>
  );
};

export function OtbPlanningScreen() {

  const vm = useOtbPlanningViewModel();

  const [selectedCycleId, setSelectedCycleId] = useState(1);
  const [performanceCycleId, setPerformanceCycleId] = useState(1);
  const [activeView, setActiveView] = useState(OTB_VIEWS.OPEN_TO_BUY);
  const [sidebarWidth, setSidebarWidth] = useState(220);

  const isPerformanceView = activeView === OTB_VIEWS.OTB_PERFORMANCE.VALUE;
  
  const vm_otb = useOtbViewModel({
    shouldFetchOtbConsolidated: activeView === OTB_VIEWS.OPEN_TO_BUY || activeView === OTB_VIEWS.DETAILED_OTB,
    shouldFetchOtbDetail: activeView === OTB_VIEWS.DETAILED_OTB,
    shouldFetchOtbCycles: true,
    shouldFetchOtbPerformanceByLevel: isPerformanceView,
    shouldFetchSalesPlan: activeView === OTB_VIEWS.SALES_PLAN,
    cycleId: selectedCycleId,
    performanceCycleId: isPerformanceView && performanceCycleId
  });

  if(vm_otb?.uiState?.isLoadingOtbData || vm_otb?.uiState?.isLoadingOtbCycles) 
    return <LoadingContent label={"Carregando dados..."} type={LOADING_CONTENT_TYPE.API_PAGE_DATA}/>  

  return (
    <Default>
      <div style={{
        display: "flex",
        height: "100%",
        backgroundColor: SYSTEM_COLORS.WHITE.ALABASTER,
        fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif",
        overflow: "hidden",
        marginLeft: "calc(72px - 5rem)",
        marginTop: "-0.2rem",
      }}>

          <SidebarForOtb
            actions={{
              setActiveView: setActiveView,
              selectOtb: (cycleId) => {
                setSelectedCycleId(cycleId);
                setActiveView(OTB_VIEWS.DETAILED_OTB);
              },
              toggleOtbSidebar: vm_otb?.actions?.toggleOtbSidebar,
              onWidthChange: setSidebarWidth
            }}
            ctx={{
              otbs: vm_otb?.ctx?.otbCycles,
              selectedOtbId: selectedCycleId,
            }}
            uiState={{
              activeView: activeView,
              otbSidebarOpen: vm_otb?.uiState?.otbSidebarOpen,
              showSidebar: true
            }}
          />
        

        <div style={{ flex: 1, minWidth: 0, marginLeft: sidebarWidth, padding: "24px 32px" }}>
          {activeView === OTB_VIEWS.OPEN_TO_BUY && (
            <OpenVsExcessosSection 
              actions={{ openNovoOtbModal: vm?.actions?.openNovoOtbModal, setSelectedCycleId: setSelectedCycleId }} 
              ctx={{
                openToBuyByCategoryTableData: vm_otb?.ctx?.otbCompanyByCategory,
                openToBuyCategorySalesLossRisk: vm_otb?.ctx?.otbCompanyByValue,
                otbCycles: vm_otb?.ctx?.otbCycles,
                selectedCycleId: selectedCycleId,
              }} />
          )}

          {isPerformanceView && (
            <PerformanceSection
              actions={{ setPerformanceCycleId: setPerformanceCycleId }}
              ctx={{
                performanceData: vm_otb?.ctx?.otbPerformanceByLevel,
                otbCycles: vm_otb?.ctx?.otbCycles,
                selectedPerformanceCycleId: performanceCycleId,
              }}
              uiState={{ isLoading: vm_otb?.uiState?.isLoadingOtbPerformanceByLevel }}
            />
          )}

          {/* {activeView === OTB_VIEWS.OTB_CONFIGURATION && (
            <SetupSection 
              actions={{
                
                //
                updateSetup: vm?.actions?.updateSetup,
                updateLeadTime: vm?.actions?.updateLeadTime,
                deleteLeadTime: vm?.actions?.deleteLeadTime,
                addLeadTime: vm?.actions?.addLeadTime,
                salvarSetup: vm?.actions?.salvarSetup
              }} 
              ctx={{
                //
                setup: vm?.ctx?.setup
              }} 
              uiState={{
                //
                setupSaved: vm?.uiState?.setupSaved
              }} />
          )} */}
        </div>
      </div>

      {vm.uiState.showNovoOtbModal && (
        <NovoOtbModal actions={vm.actions} ctx={vm.ctx} uiState={vm.uiState} />
      )}
    </Default>
  );
};